import api from "../api/axiosInstance";

/// src/services/EstadisticasService.js

/**
 * Convierte Date o string a yyyy-MM-dd (LocalDate string para el DTO)
 * Acepta:
 *  - Date object
 *  - string con formato "yyyy-MM-dd" (se devuelve igual)
 */
const toLocalDateString = (d) => {
    if (!d) return null;
    if (typeof d === "string") return d;
    const dt = new Date(d);
    const yyyy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const dd = String(dt.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
};

/**
 * Llama al POST /propietario/estadisticas
 * filtro: { fechaDesde, fechaHasta, modo, tipoPago }
 * fechaDesde/fechaHasta pueden ser Date o string "yyyy-MM-dd"
 */
export const getEstadisticasService = async (filtro) => {
    try {
        const payload = {
            fechaDesde: toLocalDateString(filtro.fechaDesde),
            fechaHasta: toLocalDateString(filtro.fechaHasta),
            modo: filtro.modo || null,
            tipoPago: filtro.tipoPago || null,
        };
        const res = await api.post("/propietario/estadisticas", payload);
        return res.data;
    } catch (err) {
        // propaga la info de error para el frontend
        throw err.response?.data || { mensaje: "Error al obtener estadísticas" };
    }
};

/**
 * Wrapper conveniente para cuando llamás pasando inicio/fin/tipoPago por separado.
 * Usa el mismo POST del backend (no inventa endpoint).
 */
export const getEstadisticasTipoPago = async (inicio, fin, tipoPago) => {
    return getEstadisticasService({
        fechaDesde: inicio,
        fechaHasta: fin,
        tipoPago,
    });
};

